(function () {
  'use strict';

  function initSlideshow(slideshow) {
    const slides = Array.from(slideshow.querySelectorAll('.hs-slide'));
    const dots = Array.from(slideshow.querySelectorAll('.hs-dot'));
    const autoplay = slideshow.dataset.autoplay === 'true';
    const speed = (parseInt(slideshow.dataset.speed) || 5) * 1000;

    let current = 0;
    let timer = null;

    if (slides.length <= 1) return;

    // ===== GO TO SLIDE =====
    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    // ===== AUTOPLAY =====
    function startAutoplay() {
      if (!autoplay) return;
      timer = setInterval(() => goTo(current + 1), speed);
    }

    function stopAutoplay() {
      clearInterval(timer);
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // ===== DOT CLICKS =====
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i);
        resetAutoplay();
      });
    });

    // ===== TOUCH SWIPE =====
    let touchStartX = 0;
    let touchEndX = 0;

    slideshow.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slideshow.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? current + 1 : current - 1);
        resetAutoplay();
      }
    }, { passive: true });

    // ===== PAUSE ON HOVER =====
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    // ===== START =====
    startAutoplay();
  }

  // ===== INIT =====
  function init() {
    document.querySelectorAll('.hs-slideshow').forEach(initSlideshow);
  }

  // Handle Shopify theme editor reloads
  document.addEventListener('shopify:section:load', function (e) {
    const slideshow = e.target.querySelector('.hs-slideshow');
    if (slideshow) initSlideshow(slideshow);
  });

  // Handle theme editor block select (jump to that slide)
  document.addEventListener('shopify:block:select', function (e) {
    const slide = e.target;
    if (!slide.classList.contains('hs-slide')) return;
    const slideshow = slide.closest('.hs-slideshow');
    if (!slideshow) return;
    const slides = Array.from(slideshow.querySelectorAll('.hs-slide'));
    const index = slides.indexOf(slide);
    if (index !== -1) {
      slides.forEach(s => s.classList.remove('is-active'));
      slideshow.querySelectorAll('.hs-dot').forEach(d => d.classList.remove('is-active'));
      slide.classList.add('is-active');
      const dot = slideshow.querySelectorAll('.hs-dot')[index];
      if (dot) dot.classList.add('is-active');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
